import React, { Component } from 'react';

/**
 * Fiche de stage rendue depuis l'entité `Stage` de la base.
 *
 * Les deux premières sessions ont chacune leur page écrite à la main
 * (`Stage1.js`, `Stage2.js`) : elles contiennent des captures, un récit et une
 * attestation que le modèle ne sait pas stocker. Ce composant sert aux sessions
 * qui n'ont pas de page dédiée, pour qu'un stage ajouté dans l'admin soit
 * consultable sans passer par du code.
 *
 * Style historique du front, cf. docs/STYLE_FRONT_LEGACY.md.
 */
export default class StageDetail extends Component {

	rubrique(titre, valeurs) {
		if (!valeurs || valeurs.length === 0) return null;
		return (
			<div><b>❯ { titre } : </b> { valeurs.join(', ') }</div>
		);
	}

	render() {
		const { stage } = this.props;
		if (!stage) return null;

		return (
			<>
				<div className="service-area section-gap white">
					<div className="container">
						<div className="row">

							<div className="col-lg-3 col-md-6">
								<div className="single-service wow fadeInUp py-4" data-wow-duration="0.8s">
									<span className="lnr lnr-apartment"> </span>
									<h4>
										<span>Entreprise</span> d'accueil
									</h4>
									<p>
										{ stage.company }<br/>
										{ stage.companyAddress && <>{ stage.companyAddress }<br/></> }
										{ stage.companyPhone && <>{ stage.companyPhone }<br/></> }
										{ stage.companyEmail && <>{ stage.companyEmail }<br/></> }
										{ stage.companyWebsite && (
											<a href={ stage.companyWebsite } target="_blank" rel="noreferrer noopener">Site web</a>
										) }
									</p>
								</div>
							</div>

							<div className="col-lg-9 col-md-6">
								<div className="row">
									<div className="col-lg-12">
										<div className="section-title">
											<h2>Information</h2>
											<div>
												{ stage.period && <div><b>❯ Période : </b> { stage.period }</div> }
												{ this.rubrique('Projet(s)', stage.projects) }
												{ this.rubrique('Technologie(s)', stage.technologies) }
												{ this.rubrique('Framework', stage.frameworks) }
												{ this.rubrique('Base de données', stage.databases) }
											</div>
										</div>
									</div>
								</div>
							</div>

							{ stage.description && (
								<div className="col-lg-12 mt-5">
									<h3 className="text-heading">Le stage</h3>
									<p>{ stage.description }</p>
								</div>
							) }

							{ stage.imageUrl && (
								<div className="col-lg-12 mt-4">
									<img className="img-fluid" src={ stage.imageUrl } alt={ stage.title } loading="lazy" />
								</div>
							) }

						</div>
					</div>
				</div>
			</>
		);
	}
}
